import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import { router } from "./routes";
import { ThemeProvider } from "./context/ThemeContext";
import { LanguageProvider } from "./context/LanguageContext";
import "./App.css";
import { AuthProvider } from "./context/AuthContext";
import { NativePlatformProvider } from "./context/NativePlatformContext";
import NativeHashBootstrap from "./components/native/NativeHashBootstrap";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        const status = (error as { status?: number })?.status;
        if (status === 401 || status === 403) return false;
        return failureCount < 2;
      },
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <LanguageProvider>
        <NativePlatformProvider>
        <AuthProvider>
          <TooltipProvider>
            <NativeHashBootstrap />
            <RouterProvider router={router} />
            <Sonner />
          </TooltipProvider>
        </AuthProvider>
        </NativePlatformProvider>
        </LanguageProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
